import { ReferralStatus } from '@app/api-module/control-centre-api-client';
import { BadgeClass } from './css-badge-classes';

export const ReferralStatusClassMapping: Map<ReferralStatus, BadgeClass> = new Map([
    [ReferralStatus.Declined, BadgeClass.Declined],
    [ReferralStatus.Cancelled, BadgeClass.Cancelled],
    [ReferralStatus.None, BadgeClass.None],
    [ReferralStatus.New, BadgeClass.None],
    [ReferralStatus.AwaitingAssignment, BadgeClass.AwaitingAssignment],
    [ReferralStatus.AwaitingDecision, BadgeClass.AwaitingDecision],
    [ReferralStatus.OnHold, BadgeClass.ReviewReferralDetails],
    [ReferralStatus.Deferred, BadgeClass.Deferred],
    [ReferralStatus.AwaitingAcknowledgement, BadgeClass.AwaitingAcknowledgement],
    [ReferralStatus.RequiresFollowUp, BadgeClass.AwaitingFollowUp],
    [ReferralStatus.FollowUpInProgress, BadgeClass.AwaitingAcknowledgement],
    [ReferralStatus.FollowedUp, BadgeClass.AwaitingAcknowledgement],
    [ReferralStatus.Acknowledged, BadgeClass.Acknowledged],
    [ReferralStatus.Refused, BadgeClass.None],
    [ReferralStatus.ImagesReceived, BadgeClass.None],
    [ReferralStatus.Reported, BadgeClass.None],
    [ReferralStatus.ClinicalDiscussionRequired, BadgeClass.ClinicalDiscussionRequired]
]);
